import React, { useEffect } from 'react';
import './GeometricBackground.css';

const GeometricBackground = () => {
  useEffect(() => {
    const handleScroll = () => {
      const scrolled = window.pageYOffset;
      const triangles = document.querySelectorAll('.triangle');
      
      triangles.forEach((triangle, index) => {
        const speed = 0.5 + (index * 0.2);
        triangle.style.transform = `translateY(${scrolled * speed}px)`;
      });
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="geometric-bg">
      <div className="triangle triangle-1"></div>
      <div className="triangle triangle-2"></div>
      <div className="triangle triangle-3"></div>
    </div>
  );
};

export default GeometricBackground;

